import { useAIAgentInterface } from './useAIAgentInterface';
import { useLocalStorageState } from './useLocalStorageState';

/**
 * useAIAgentSidebarState - Simplified hook using localStorage strategy
 * 
 * This hook now directly uses localStorage for UI state and only gets
 * business logic from the interface layer.
 * 
 * ✅ ALIGNED WITH LOCALSTORAGE STRATEGY:
 * - Direct localStorage access for UI state
 * - Business logic from interface layer
 * - No state synchronization issues
 * - Single source of truth
 */
export const useAIAgentSidebarState = () => {
  // Get UI state directly from localStorage
  const localStorageState = useLocalStorageState();
  
  // Get business logic from interface layer
  const aiAgentInterface = useAIAgentInterface();



  return {
    // State (read directly from localStorage)
    activeTab: localStorageState.activeTab,
    inputValue: localStorageState.inputValue,
    user: aiAgentInterface.user,
    
    // Operations (from localStorage)
    setActiveTab: localStorageState.setActiveTab,
    handleApplyPrompt: localStorageState.applyPrompt,
    handleInputChange: localStorageState.setInputValue,
    
    // Business operations (from interface)
    switchToChatTab: aiAgentInterface.switchToChatTab,
    switchToThreadsTab: aiAgentInterface.switchToThreadsTab
  };
}; 